/**
 * Functions related to WordPress' admin bar.
 */

const adminBar = () => {
  const adminBarID = 'wpadminbar';
  let adminBarElement;
  let isDisplayed = false;
  let isSticky = false;

  const hasPositionAbsolute = () => {
    if (isDisplayed) {
      const adminBarStyles = getComputedStyle(adminBarElement);
      const adminBarPosition = adminBarStyles.position;
      return adminBarPosition === 'absolute';
    }
    return false;
  };

  const init = () => {
    adminBarElement = document.getElementById(adminBarID);
    isDisplayed = adminBarElement !== null;
    isSticky = hasPositionAbsolute();
  };

  const onResize = () => {
    isSticky = hasPositionAbsolute();
  };

  return {
    getElement: () => adminBarElement,
    isDisplayed: () => isDisplayed,
    isSticky: () => isSticky,
    init,
    onResize,
  };
};

export default adminBar();
